/*
 * Developed by CQ Inversiones SAS.  Copyright (c) 2025. All rights reserved.
 * Desarrollado por CQ Inversiones SAS.  Copyright (c) 2025. Todos los derechos reservados.
 */

/*
 * Project:      mkad-frontend
 * Developed by: Juan David Pelaez Cumbe
 * Date:         15/04/25
 * Module name:  management-storage-key
 * File name:    management-storage-key.ts
 * IDE:          WebStorm
 */


export const MANAGEMENT_STORAGE_KEY = 'mkad_manage';
